import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';
import { AmountRangeStatus, AmountUnavailableMessage } from '../plans/amountRange';

export interface AmountRangeState {
    status: AmountRangeStatus | null;
    message: AmountUnavailableMessage | null;
    searchKey: string | null;
}

const initialState: AmountRangeState = {
    status: null,
    message: null,
    searchKey: null,
};

function useAmountRange() {
    const [amountRange, setAmountRange] = useState<AmountRangeState>(initialState);

    return {
        ...amountRange,
        setAmountRange,
    };
}

export const AmountRangeStore = createStore(useAmountRange);
